import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=7a7381ba&"
import script from "./Unauthorized.vue?vue&type=script&setup=true&lang=js&"
export * from "./Unauthorized.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports